import React from 'react'

function InterfaceView({interfaceData}) {
  return (
    <div>{interfaceData.name + interfaceData.place}</div>
  )
}

export default InterfaceView